export const titular = [
    {
        "nombre" : "Elizabeth Quintanar Gómez",
        "imagen" : "/assets/imgs/secretaria2.jpg",
        "funcion" : "Fortalecer el crecimiento del sector turístico mediante el impulso, la promoción, la calidad y la innovación en las acciones alineadas estratégicamente con el Plan Estatal de Desarrollo, a partir de una mayor inversión pública y privada, que logre un crecimiento económico."
    }
]


//https://cdn.hidalgo.gob.mx/gobierno/images/gabinete/ElizabethQuintanarGomez.png